var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCollapse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 40,
    viewBox: "0 0 25 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 39.5,
    width: 24,
    height: 39,
    rx: 4.5,
    transform: "rotate(-180 24.5 39.5)",
    fill: "white",
    stroke: "#CEDDE7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53125 23.5156L5.48438 19.4687C5.34766 19.332 5.34766 19.1406 5.48438 19.0039L9.53125 14.957C9.66797 14.8203 9.88672 14.8203 9.99609 14.957L10.543 15.5039C10.6797 15.6133 10.6797 15.832 10.543 15.9687L7.89063 18.5117L14.6719 18.5117C14.8633 18.5117 15 18.6758 15 18.8398L15 19.6055C15 19.7969 14.8633 19.9336 14.6719 19.9336L7.89063 19.9336L10.543 22.5039C10.6797 22.6406 10.6797 22.8594 10.543 22.9687L9.99609 23.5156C9.88672 23.6523 9.66797 23.6523 9.53125 23.5156ZM16.2031 14.3281C16.2031 14.1367 16.3672 14 16.5313 14L17.2969 14C17.4883 14 17.625 14.1367 17.625 14.3281L17.625 24.1719C17.625 24.3359 17.4883 24.5 17.2969 24.5L16.5313 24.5C16.3672 24.5 16.2031 24.3359 16.2031 24.1719L16.2031 14.3281Z",
    fill: "#005587"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.b3805c0b.svg";
export { ForwardRef as ReactComponent };